  import React, { useEffect, useState, useMemo } from "react";
  import axios from 'axios';
  import withRouter from "components/Common/withRouter";
  import Breadcrumbs from "components/Common/Breadcrumb";
  import TableContainer from "components/Common/TableContainer";
  import Spinners from "components/Common/Spinner";
  import {
    Card,
    CardBody,
    Col,
    Container,
    Row,
    Modal,
    ModalHeader,
    ModalBody,
    Label,
    FormFeedback,
    Input,
    Form,
    UncontrolledTooltip,
    DropdownToggle,
    DropdownMenu,
    DropdownItem,
    UncontrolledDropdown,

  } from "reactstrap";
  import toast from "react-hot-toast";
  import DeleteModal from "components/Common/DeleteModal";
  import Select from "react-select";
  import { useFormik } from "formik";
  import * as Yup from "yup";
  import {
    getAllEvents,
    getEventVenuesBySlug,
    getUsersByOrganizer,
    createUserByOrganizer,
    updateUserByOrganizer,
    deleteUserByOrganizer,
  } from "api";
  import { handleError } from "utils/errorHandler";
  import { head, set } from "lodash";

  const NewUser = () => {
    document.title = "New User | EventoX";

    const [modal, setModal] = useState(false);
    const [isEdit, setIsEdit] = useState(false);
    const [isLoading, setLoading] = useState(false);
    const [events, setEvents] = useState([]);
    const [venues, setVenues] = useState([]);
    const [users, setUsers] = useState([]);
    const [selectedEvent, setSelectedEvent] = useState(null);
    const [selectedVenue, setSelectedVenue] = useState(null);
    const [selectedEventForAdd, setSelectedEventForAdd] = useState(null);
    const [selectedVenueForAdd, setSelectedVenueForAdd] = useState(null);
    const [eventVenuesForAdd, setEventVenuesForAdd] = useState([]);
    const [currentUserId, setCurrentUserId] = useState(null);
    const [status, setStatus] = useState("active")
    const [deleteModal, setDeleteModal] = useState(false);
    const [selectedUser, setSelectedUser] = useState(null);
    const statusOptions = [
      { value: "active", label: "Active" },
      { value: "inactive", label: "Inactive" },
    ];
    
  
    const validationSchema = useMemo(() => {
      return Yup.object().shape({
        name: Yup.string().required("Name is required"),
        email: Yup.string().email("Invalid email").required("Email is required"),
        phoneNo: Yup.string().required("Phone number is required"),
        password: isEdit
          ? Yup.string() // optional when editing
          : Yup.string().required("Password is required"),
        eventSlug: Yup.string().required("Event is required"),
        venueId: Yup.string().required("Venue is required"),
        organizerId: Yup.string().required("Organizer is required"),
      });
    }, [isEdit]);
    
    const validation = useFormik({
      enableReinitialize: true,
      initialValues: {
        name: "",
        email: "",
        phoneNo: "",
        password: "",
        eventSlug: "",
        venueId: "",
        organizerId: "",
        status: "active",
      },
      validationSchema,
      
      onSubmit: async values => {
        setLoading(true);
        try {
          const payload = {
            userId: currentUserId, // for update only
            username: values.email,
            email: values.email,
            name: values.name,
            phoneNo: values.phoneNo,
            address: values.address || null,
            location: values.location || null,
            userRole: values.userRole || "4", // optional default
            venueId: selectedVenueForAdd?.value,
            eventSlug: selectedEventForAdd?.value,
            status: values.status,
            ...(isEdit ? {} : { password: values.password || "default123" }) // add password only when creating

          };
      
          const organizerId = selectedEventForAdd?.organizerId;
      
          if (!organizerId) {
            toast.error("Organizer ID missing. Please select an event.");
            return;
          }
      
          if (isEdit) {
            await updateUserByOrganizer(currentUserId, { ...payload, organizerId });
            toast.success("User updated successfully");
          } else {
            const createResp = await createUserByOrganizer(organizerId, payload);
            if (createResp) {
              toast.success("User created successfully");
            } else {
              toast.error("Failed to create user");
            }
          }
      
          await getUsersList(selectedEvent?.organizerId, selectedVenue, selectedEvent?.value);
          validation.resetForm();
          toggle();
        } catch (error) {
          console.error("User create/update error:", error);
          toast.error("Error saving user");
        } finally {
          setLoading(false);
        }
      }
      
      
    });

    const fetchEvents = async () => {
      try {
        const resp = await getAllEvents();
        const eventsMapped = resp.map(event => ({
          value: event.slugId,
          label: event.eventName,
          organizerId: event.Organizer?.organizerId,
        }));
        setEvents(eventsMapped);
      } catch (error) {
        handleError(error);
      }
    };

    useEffect(() => {
      const fetchInitialData = async () => {
        try {
          const resp = await getAllEvents();
          const eventsMapped = resp.map(event => ({
            value: event.slugId,
            label: event.eventName,
            organizerId: event.Organizer?.organizerId,
          }));
    
          setEvents(eventsMapped);
          setSelectedEvent(null);
          setSelectedVenue(null);
          setUsers([]); // 🔥 Reset users on load
        } catch (error) {
          handleError(error);
        }
      };
    
      fetchInitialData();
    }, []);
    
    const getUsersList = async (organizerId, venue, eventSlug) => {
      try {
        const resp = await getUsersByOrganizer(organizerId);
    
        const filtered = resp.filter(user => {
          const matchVenue = venue ? user.venueId === venue.value : true;
          const matchEvent = eventSlug
            ? user?.venue?.event?.slugId === eventSlug
            : true;
    
          return matchVenue && matchEvent;
        });
    
        setUsers(filtered); 
      } catch (error) {
        console.error("Error fetching user list:", error);
      }
    };
    
    
    
    const getVenuesList = async slug => {
      try {
        const resp = await getEventVenuesBySlug(slug);
        const mapped = resp.map(v => ({ value: v.venueId, label: v.venueName }));
        setVenues(mapped);
      } catch (error) {
        handleError(error);
      }
    };

    const getEventVenueForAdd = async eventId => {
      try {
        const resp = await getEventVenuesBySlug(eventId);
        const mapped = resp.map(item => ({
          value: item.venueId,
          label: item.venueName,
        }));
        setEventVenuesForAdd(mapped);
      } catch (error) {
        handleError(error);
      }
    };

    const toggle = () => {
      setModal(prev => !prev);
    };

    const handleEventSelect = async e => {
      setSelectedEvent(e);
      setSelectedVenue(null);
      setUsers([]); 
    
      await getVenuesList(e.value);
      await getUsersList(e.organizerId, null, e.value);
    };
    
    

    const handleVenueSelect = async v => {
      setSelectedVenue(v);
      if (selectedEvent) {
        await getUsersList(selectedEvent?.organizerId, v, selectedEvent?.value); 
      }    
    };

    const handleUserClick = user => {
      const eventData = {
        value: user.venue?.event.slugId,
        label: user.venue?.event.eventName,
        organizerId: user.organizerId,
      };
      const venueData = {
        value: user.venueId,
        label: user.venue?.venueName,
      };

      setSelectedEvent(eventData);
      setSelectedVenue(venueData);
      setSelectedEventForAdd(eventData);
      setSelectedVenueForAdd(venueData);
      getEventVenueForAdd(eventData.value);
      setCurrentUserId(user.userId);
      setIsEdit(true);

      validation.setValues({
        name: user.name,
        email: user.email,
        phoneNo: user.phoneNo,
        password: "",
        eventSlug: user.eventSlug || eventData.value,
        venueId: user.venueId || venueData.value,
        organizerId: user.organizerId,
        status: user.status || "active",
      });

      toggle();
    };

    const handleDeleteUser = async () => {
      if (!selectedUser) return;
    
      try {
        await deleteUserByOrganizer(selectedUser.userId);
        toast.success("User deleted successfully");
        await getUsersList(
          selectedEvent?.organizerId,
          selectedVenue,
          selectedEvent?.value
        );
      } catch (error) {
        handleError(error);
        toast.error("Error deleting user");
      }
    
      setDeleteModal(false);
      setSelectedUser(null);
    };
    

    const columns = useMemo(() => [
      {header: "Name",
        accessorKey: "name",
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: "Email",
        accessorKey: "email",
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: "Phone No",
        accessorKey: "phoneNo",
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header:"Venue",
        accessorKey: "venue.venueName",
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header:"Status",
        accessorKey: "status",
        enableColumnFilter: true,
        enableSorting: true,
        filterFn: (row, columnId, filterValue) => {
          const val = row.getValue(columnId);
          if (val === undefined || val === null) return false;
          return String(val).toLowerCase().includes(String(filterValue).toLowerCase());
        },
      },
      {
        header: 'Created Date',
        accessorKey: 'createdAt',
        enableColumnFilter: true,
        enableSorting: true,
        filterFn: (row, columnId, filterValue) => {
          const val = row.getValue(columnId);
          if (!val) return false;
          const display = new Date(val).toLocaleDateString();
          return display.toLowerCase().includes(String(filterValue).toLowerCase());
        },
        cell: (cell) => {
          const date = cell.getValue();
          return date ? new Date(date).toLocaleDateString() : "-";
        }
      },
      {
    header: 'Action',
    cell: (cellProps) => {
      const data = cellProps.row.original;
  

      return (
        <UncontrolledDropdown>
          <DropdownToggle tag="a" className="card-drop">
            <i className="mdi mdi-dots-horizontal font-size-18"></i>
          </DropdownToggle>

          <DropdownMenu className="dropdown-menu-end">
            <DropdownItem onClick={() => {setSelectedUser(data); setDeleteModal(true);}}>
              <i className="mdi mdi-delete font-size-16 text-danger me-1" id={`delete-user-${data.userId}`}></i>
              Delete
            </DropdownItem>
            <UncontrolledTooltip placement="top" target={`delete-user-${data.userId}`}>
              Delete
            </UncontrolledTooltip>
            <DropdownItem onClick={() => handleUserClick(data)}>
              <i className="mdi mdi-pencil font-size-16 text-success me-1" id={`edit-user-${data.userId}`}></i>
              Edit
            </DropdownItem>
            <UncontrolledTooltip placement="top" target={`edit-user-${data.userId}`}>
              Edit
            </UncontrolledTooltip>
          </DropdownMenu>
        </UncontrolledDropdown>
      );
    }
  }

      


    ], []);

    return (
        <React.Fragment>
            <DeleteModal
          show={deleteModal}
          onDeleteClick={handleDeleteUser}
          onCloseClick={() => setDeleteModal(false)}
        />
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title="Dashboard" breadcrumbItem="New User" />
          <Row>
            {isLoading ? (
              <Spinners setLoading={setLoading} />
            ) : (
              <Col lg="12">
                <Card>
                  <CardBody>
                    <Row className="mb-3">
                      <Col xl="5">
                        <Select
                          value={selectedEvent}
                          onChange={handleEventSelect}
                          options={events}
                          placeholder="Select Event"
                          styles={{ menu: prov => ({ ...prov, zIndex: 9999 }) }}
                        />
                      </Col>
                      {/* <Col xl="5">
                        <Select
                          value={selectedVenue}
                          onChange={handleVenueSelect}
                          options={venues}
                          placeholder="Select Venue"
                          styles={{ menu: prov => ({ ...prov, zIndex: 9999 }) }}
                        />
                      </Col> */}
                    </Row>

                    <TableContainer
                      columns={columns}
                      data={users || []}
                      isGlobalFilter
                      isPagination
                      isCustomPageSize
                      isAddButton
                      handleUserClick={() => {
                        setIsEdit(false);
                        setSelectedEventForAdd(null);
                        setSelectedVenueForAdd(null);
                        validation.resetForm();
                        toggle();
                      }}
                      buttonClass="btn btn-success btn-rounded waves-effect waves-light addContact-modal mb-2"
                      buttonName="New User"
                      tableClass="align-middle table-nowrap table-hover dt-responsive nowrap w-100 dataTable no-footer dtr-inline"
                      theadClass="table-light"
                      paginationWrapper="dataTables_paginate paging_simple_numbers pagination-rounded"
                      pagination="pagination"
                    />
                  </CardBody>
                </Card>
              </Col>
            )}
          </Row>

          {/* Modal */}
          <Modal isOpen={modal} toggle={toggle}>
            <ModalHeader toggle={toggle}>{isEdit ? "Edit User" : "Add New User"}</ModalHeader>
            <ModalBody>
              <Form
                onSubmit={e => {
                  e.preventDefault();
                  validation.handleSubmit();
                }}
              >
                <Row>
                  <Col xs={12}>
                    {/* Event */}
                    <div className="mb-3">
                      <Label>Select Event</Label>
                      <Select
                        value={selectedEventForAdd}
                        onChange={data => {
                          validation.setFieldValue("eventSlug", data.value);
                          validation.setFieldValue("organizerId", data.organizerId);
                          setSelectedEventForAdd(data);
                          getEventVenueForAdd(data.value);
                        }}
                        options={events}
                        placeholder="Select Event"
                        isDisabled={isEdit}
                        styles={{ menu: prov => ({ ...prov, zIndex: 9999 }) }}
                      />
                      {validation.touched.eventSlug && validation.errors.eventSlug && (
                        <FormFeedback type="invalid" className="d-block">
                          {validation.errors.eventSlug}
                        </FormFeedback>
                      )}
                    </div>

                    {/* Venue */}
                    <div className="mb-3">
                      <Label>Select Venue</Label>
                      <Select
                        value={selectedVenueForAdd}
                        onChange={data => {
                          validation.setFieldValue("venueId", data.value);
                          setSelectedVenueForAdd(data);
                        }}
                        options={eventVenuesForAdd}
                        placeholder="Select Venue"
                        isDisabled={isEdit}
                        styles={{ menu: prov => ({ ...prov, zIndex: 9999 }) }}
                      />
                      {validation.touched.venueId && validation.errors.venueId && (
                        <FormFeedback type="invalid" className="d-block">
                          {validation.errors.venueId}
                        </FormFeedback>
                      )}
                    </div>

                    {/* Name */}
                    <div className="mb-3">
                      <Label>Name</Label>
                      <Input
                        name="name"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.name}
                        invalid={validation.touched.name && !!validation.errors.name}
                      />
                      <FormFeedback>{validation.errors.name}</FormFeedback>
                    </div>

                    {/* Email */}
                    <div className="mb-3">
                      <Label>Email</Label>
                      <Input
                        name="email"
                        type="email"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.email}
                        invalid={validation.touched.email && !!validation.errors.email}
                      />
                      <FormFeedback>{validation.errors.email}</FormFeedback>
                    </div>
                    <div className="mb-3">
                    <Label className="form-label">Status</Label>
                    <Select
                      name="status"
                      options={statusOptions}
                      placeholder="Select Status"
                      value={statusOptions.find(opt => opt.value === validation.values.status) || null}
                      onChange={(option) => validation.setFieldValue("status", option?.value || "")}
                      onBlur={() => validation.setFieldTouched("status", true)}
                      classNamePrefix="rs"
                      className={validation.touched.status && validation.errors.status ? "is-invalid" : ""}
                    />

                    {validation.touched.status && validation.errors.status && (
                      <FormFeedback type="invalid" className="d-block">
                        {validation.errors.status}
                      </FormFeedback>
                    )}
                  </div>

                    {/* Phone */}
                    <div className="mb-3">
                      <Label>Phone No</Label>
                      <Input
                        name="phoneNo"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.phoneNo}
                        invalid={validation.touched.phoneNo && !!validation.errors.phoneNo}
                      />
                      <FormFeedback>{validation.errors.phoneNo}</FormFeedback>
                    </div>

                    {/* Password */}
                    <div className="mb-3">
                      <Label>Password</Label>
                      <Input
                        name="password"
                        type="password"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.password}
                        invalid={validation.touched.password && !!validation.errors.password}
                      />
                      <FormFeedback>{validation.errors.password}</FormFeedback>
                    </div>
                  </Col>
                </Row>
                <div className="text-end">
                  <button type="submit" className="btn btn-success">
                    {isLoading ? "Saving..." : "Save"}
                  </button>
                </div>
              </Form>
            </ModalBody>
          </Modal>
        </Container>
      </div>
      </React.Fragment>
    );
  };

  export default withRouter(NewUser);